import styled from "@emotion/styled";
import { SubmitButton as SignUpNewsletterSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  ActionContainer as SignUpNewsletterActionContainer,
  Title as SignUpNewsletterTitle,
  TitleContainer as SignUpNewsletterTitleContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  CheckEmailMessage as SignUpSuccessCheckEmailMessage,
  Container as SignUpSuccessContainer,
  IconContainer as SignUpSuccessIconContainer,
  Title as SignUpSuccessTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import { StyledSignUpNewsletter } from "scmp-sdk/components/newsletter/newsletter-widget/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "portrait",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: false,
    summaryFontStyle: "medium",
    titleFontStyle: "small",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: false,
    titleFontStyle: "small",
  },
};

type ContainerProps = {
  theme?: ThemeType;
};

export const Container = styled.div<ContainerProps>`
  ${SignUpNewsletterTitle} {
    color: #001246;
  }

  ${SignUpNewsletterTitleContainer} {
    margin-block-end: 12px;
  }

  ${SocialButtonIconContainer} {
    background-color: #ffffff;
  }

  ${StyledSignUpNewsletter} {
    color: #001246;
  }

  ${SignUpNewsletterSubmitButton} {
    color: #ffffff;
  }

  ${SignUpNewsletterActionContainer} {
    margin-block-end: 8px;
  }

  ${SignUpSuccessContainer} {
    grid-template-areas:
      "Icon Title"
      "Icon Footer";
    grid-template-columns: 25px 1fr;
    justify-items: flex-start;

    max-inline-size: 402.5px;
    margin-block: 0;
    margin-inline: auto;

    text-align: start;

    ${SignUpSuccessTitle} {
      margin-block-end: 4px;
      margin-block-end: 4px;

      color: #001246;
      font-weight: 400;
      font-family: ${fontMerriweather};
    }
    ${SignUpSuccessCheckEmailMessage} {
      margin-block-end: 0;
      padding-block-start: 0;

      color: #000000;
      font-size: 12px;
      font-family: ${fontRoboto};
      line-height: 14px;
    }
    ${SignUpSuccessIconContainer} {
      margin-block-end: 0;
    }
  }
`;
